
import React from "react";
import { Field, Form, reduxForm } from 'redux-form';
import { Row, Col, Button, Label, FormGroup } from 'reactstrap';
import { ReduxSpinner, ReduxSelectField, ReduxCheckBoxField, ReduxTextAreaInput } from '../../components/ReduxInput';


class AccessorialsForm extends React.Component {

  render() {
    const { previous, handleSubmit, driverDetentionOptions } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs="12" md="3">
            <FormGroup check className="checkbox">
              <Field
                id="Hazardous_Material"
                text="Hazardous"
                name="Hazardous Material"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Hazardous Material</Label>
            </FormGroup>
            <FormGroup check className="checkbox">
              <Field
                id="Triaxial_Fee"
                text="Triaxle"
                name="Triaxle Fee"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Triaxle</Label>
            </FormGroup>
            <FormGroup check className="checkbox">
              <Field
                id="Overweight"
                text="Overweight"
                name="Overweight"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Overweight</Label>
            </FormGroup>
            <FormGroup check className="checkbox">
              <Field
                id="Chassis_Positioning"
                text="Chassis Positioning"
                name="Chassis Positioning"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Chassis Positioning</Label>
            </FormGroup>
            <FormGroup check className="checkbox">
              <Field
                id="Residence"
                text="Residence"
                name="Residence"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Residence</Label>
            </FormGroup>
            <FormGroup check className="checkbox">
              <Field
                id="Yard_Pull"
                text="Yard Pull"
                name="Yard Pull"
                className="checkbox style-0"
                component={ReduxCheckBoxField}
              />
              <Label >Yard Pull</Label>
            </FormGroup>
          </Col>
          <Col xs="12" md="6">
            <FormGroup>
              <Label   >Chassis Rental (Days)</Label>
              <Field
                id={"Chassis_Rental"}
                bsSize="sm"
                placeholder={"asfsdafsdasf"}
                min={0}
                max={10}
                name={"Chassis Rental"}
                component={ReduxSpinner}
              />
            </FormGroup>
            <FormGroup inline >
              <Label >Yard Storage (Days) </Label>
              <Field
                bsSize="sm"
                id={"Yard_Storage"}
                //placeholder={0}
                name={"Yard Storage"}
                min={0}
                max={10}
                component={ReduxSpinner}
              />
            </FormGroup>
            <FormGroup inline >
              <Label >Scale (Per Scale)</Label>
              <Field
                bsSize="sm"
                min={0}
                max={10}
                id={"Scale_Charges"}
                name={"Scale Charges"}
                component={ReduxSpinner}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="3" md="9">
          <FormGroup inline >
                  <Label >Additional Information</Label>
                  <Field
                    id={"remarks"}
                    name={"remarks"}
                    component={ReduxTextAreaInput}
                  />
                </FormGroup>
          </Col>
        </Row>
        <hr />
        <FormGroup>
          <Button
            onClick={previous}
            color="previous"
          >Previous</Button>{' '}
          <Button id="accesorialsNext" type="submit" color="primary" className="text-white"
          >Next</Button>{' '}
        </FormGroup>
      </Form >
    );
  }
}

export default reduxForm({
  form: "AccessorialsForm",
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(AccessorialsForm);



// WEBPACK FOOTER //
// ./src/components/AccessorialsForm/AccessorialsForm.js